import React from 'react';
import { Box, Container, Paper, Tab, Tabs } from '@mui/material';
import { Search, Analytics } from '@mui/icons-material';
import SectionTitle from './crt/SectionTitle';
import SEODashboard from './SEODashboard';
import GA4Dashboard from './GA4Dashboard';
import { useUrlIntState } from '../hooks/useUrlState';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

/**
 * Bundles the two website-facing dashboards (SEO / Search Console + GA4
 * traffic) under one tab so the top platform-nav doesn't have two
 * adjacent tabs that are basically "website stats".
 */
const WebsiteDashboard: React.FC = () => {
  const [active, setActive] = useUrlIntState('web_tab', 0);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box mb={4}>
        <SectionTitle sub="&gt; Search visibility + on-site behavior across spoutlore.com_">
          WEBSITE :: ANALYTICS
        </SectionTitle>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={active}
          onChange={(_, v) => setActive(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab icon={<Search />} label="SEO / Search Console" />
          <Tab icon={<Analytics />} label="GA4 Traffic" />
        </Tabs>
      </Paper>

      {/* SEODashboard + GA4Dashboard each render their own Container.
          Strip the outer one here by mounting them at p:0. */}
      <TabPanel value={active} index={0}><SEODashboard /></TabPanel>
      <TabPanel value={active} index={1}><GA4Dashboard /></TabPanel>
    </Container>
  );
};

export default WebsiteDashboard;
